import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { EyeSVG } from '../svg/eye.svg';

const EyeIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <EyeSVG/>
    </div>
  );
};

export { EyeIcon };
